import { ErrorName } from './ErrorName';
import { ServerBaseError } from './ServerBaseError';

export class InternalServerError extends ServerBaseError {
    public constructor(message: string, requestId: string, detail?: unknown) {
        super(500, ErrorName.InternalServerError, { message, requestId, detail });
    }
}
